import React, { memo } from 'react';
import { BodyS } from 'components/Typography/Typography';
import CustomCheckbox from 'components/CustomCheckbox/CustomCheckbox';
import classNames from 'classnames';
import CustomRadio from 'components/CustomRadio/CustomRadio';
import styles from 'assets/jss/material-dashboard-pro-react/components/customFilterStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

type ElementType = 'multiple' | 'one';

interface IElementItem {
	title: string;
	value: string;
	show?: React.ReactElement;
}

interface IElementProps {
	type: ElementType;
	title: string;
	value: string;
	checked: string | string[];
	onChange: (e: any) => void;
	all?: boolean;
	elements: IElementItem[];
}

const Element = ({ type, value, checked, onChange, all, elements, title }: IElementProps) => {
	const classes = useStyles();

	switch (type) {
		case 'multiple': {
			const fn = () => {
				if (all) {
					if (elements.length === checked.length) {
						onChange([]);
					} else {
						onChange([...elements.map(({ value }) => value)]);
					}
				} else if (checked.includes(value)) {
					onChange(Array.isArray(checked) && checked.filter((elem) => elem !== value));
				} else {
					onChange([...checked, value]);
				}
			};

			return (
				<>
					<div className={classes.accordionElementLabel} onClick={fn}>
						<BodyS disableMargin>{title}</BodyS>
					</div>
					<CustomCheckbox
						disableLabel
						checkboxProps={{
							className: classNames(classes.checkbox, {
								[classes.checkboxUnchecked]:
									(all && checked.length === 0) || (!all && !checked.includes(value)),
							}),
						}}
						indeterminate={!!all && checked.length !== elements.length && checked.length !== 0}
						checked={all ? checked.length === elements.length : checked.includes(value)}
						onClick={fn}
					/>
				</>
			);
		}

		case 'one':
		default: {
			const fn = () => onChange([value]);
			const isChecked = checked.includes(value);
			return (
				<>
					<div className={classes.accordionElementLabel} onClick={fn}>
						<BodyS disableMargin>{title}</BodyS>
					</div>
					<CustomRadio
						checked={isChecked}
						onChange={fn}
						formControlProps={{
							className: classNames(classes.radio, {
								[classes.radioUnchecked]: !isChecked,
							}),
						}}
					/>
				</>
			);
		}
	}
};

export default memo(Element);
